// removed by extract-text-webpack-plugin
module.exports = {"DayPage":"src-components-DayPage-__DayPage-module___DayPage","innerContainer":"src-components-DayPage-__DayPage-module___innerContainer","betaNote":"src-components-DayPage-__DayPage-module___betaNote","TideSummary":"src-components-DayPage-__DayPage-module___TideSummary","TideGraph":"src-components-DayPage-__DayPage-module___TideGraph","TideGraphLegend":"src-components-DayPage-__DayPage-module___TideGraphLegend","EventTable":"src-components-DayPage-__DayPage-module___EventTable","TideStationName":"src-components-DayPage-__DayPage-module___TideStationName"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DayPage/DayPage.module.css
// module id = 1348
// module chunks = 0